import axios from "axios";

const s3Url = process.env.REACT_APP_S3_BUCKET_URL

const getIndustries = () => {
    return new Promise((resolve, reject) => {
        axios.get(`${s3Url}/constants/industries.json`)
            .then(response => resolve(response.data))
            .catch(error => reject(error.message))
    });
};

export default getIndustries;
